"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormImportPoleforemanModal = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const store_1 = require("../../store");
const FormImportPoleforemanModalCSS = {
    form: 'c-FormImportPoleforemanModal__form',
    spinner: 'c-FormImportPoleforemanModal__spinner'
};
(0, theme_1.addStyles)({
    [FormImportPoleforemanModalCSS.form]: {
        display: 'flex',
        'flex-direction': 'column',
        gap: '10px',
        width: '400px',
        height: '80px'
    },
    [FormImportPoleforemanModalCSS.spinner]: {
        display: 'flex',
        'flex-direction': 'column',
        gap: '10px',
        'justify-content': 'center',
        'text-align': 'center'
    }
});
class FormImportPoleforemanModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, existingFormVersion) {
        super(ctx);
        this.existingFormVersion = existingFormVersion;
        this.loadingDatabases = false;
        this.loadedDatabases = false;
        this.loadingOperatingCompanies = false;
        this.loadedOperatingCompanies = false;
        this.attachmentId = null;
        this.operatingCompany = null;
        this.databaseURL = null;
        this.databases = [];
        this.operatingCompanies = [];
        this.errorMessage = null;
        this.displayCancelButton = false;
        this.displaySubmitButton = false;
        this.refreshDatabases();
    }
    customButtons() {
        return [
            (0, mithril_1.m)('button', { className: 'mdl-button', onclick: () => this.close(), disabled: this.loading, type: 'button' }, (0, i18n_1.Translate)(i18n_1.T.CANCEL)),
            (0, mithril_1.m)('button', {
                className: 'mdl-button mdl-button--accent', disabled: this.errorMessage || this.loading || !this.databaseURL, onclick: () => {
                    this.refreshOperatingCompanies();
                }
            }, (0, i18n_1.Translate)(i18n_1.T.NEXT))
        ];
    }
    get nodes() {
        if (this.errorMessage) {
            return (0, mithril_1.m)('div', {}, [(0, i18n_1.Translate)(this.errorMessage)]);
        }
        if (this.loadingDatabases) {
            return (0, mithril_1.m)('div', { className: FormImportPoleforemanModalCSS.spinner }, [(0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_FETCHING_ORGS)), spinner_1.Spinner.view()]);
        }
        if (this.loadingOperatingCompanies) {
            return (0, mithril_1.m)('div', { className: FormImportPoleforemanModalCSS.spinner }, [(0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_FETCHING_OP_CO)), spinner_1.Spinner.view()]);
        }
        // If we have databases loaded, but haven't selected the operating company yet, then display the database org selector
        if (this.loadedDatabases && !this.loadedOperatingCompanies) {
            return mithril_1.m.fragment({}, [(0, mithril_1.m)('form', { className: FormImportPoleforemanModalCSS.form }, this.databases.length > 0 ? [
                    (0, mithril_1.m)('div', [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_DESCRIPTION)]),
                    (0, mithril_1.m)('select', {
                        onchange: (e) => {
                            if ('target' in e && e.target && 'value' in e.target && typeof e.target.value === 'string') {
                                this.databaseURL = e.target.value;
                                this.isSubmitButtonDisabled = false;
                            }
                        }
                    }, [
                        (0, mithril_1.m)('option', { value: '', selected: true, disabled: true }, (0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_SELECT_ORG)),
                        ...this.databases.map(db => (0, mithril_1.m)('option', { value: db.databaseURL }, db.organizationName))
                    ])
                ] : (0, mithril_1.m)('div', [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_NO_DATABASES)]))]);
        }
        if (this.loadedOperatingCompanies) {
            if (this.operatingCompanies.length === 1) {
                return (0, mithril_1.m)('div', {}, [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_SINGLE_OP_CO, this.operatingCompanies[0].name)]);
            }
            return (0, mithril_1.m)('form', { className: FormImportPoleforemanModalCSS.form }, this.operatingCompanies.length > 0 ? [
                (0, mithril_1.m)('div', [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_OP_CO_DESCRIPTION)]),
                (0, mithril_1.m)('select', {
                    onchange: (e) => {
                        if ('target' in e && e.target && 'value' in e.target && typeof e.target.value === 'string') {
                            this.operatingCompany = e.target.value;
                            this.isSubmitButtonDisabled = false;
                        }
                    },
                    disabled: this.loading
                }, [
                    (0, mithril_1.m)('option', { value: '', selected: true, disabled: true }, (0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_SELECT_OP_CO)),
                    ...this.operatingCompanies.map(op => (0, mithril_1.m)('option', { value: op.id }, op.name))
                ])
            ] : (0, mithril_1.m)('div', [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_NO_OPERATING_COMPANIES)]));
        }
        return spinner_1.Spinner.view();
    }
    importPoleForemanForm() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.setLoading(true);
                const rest = services_1.Services.Department.rest;
                yield rest.Form.Pla.importPoleforeman(Object.assign(Object.assign({ attachmentId: this.attachmentId }, (this.operatingCompany && { operatingCompanyId: parseInt(this.operatingCompany) })), (this.existingFormVersion && { existingFormVersion: this.existingFormVersion })));
                this.close();
                store_1.AppStore.FormSummary.refresh();
            }
            catch (e) {
                this.handleError(i18n_1.T.FORM_IMPORT_POLEFOREMAN_ERROR_CREATION);
            }
        });
    }
    submit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.importPoleForemanForm();
        });
    }
    refreshOperatingCompanies() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.displayCustomButtons = false;
                this.loadingOperatingCompanies = true;
                const result = yield services_1.Services.Department.rest.Form.Pla.savePoleForemanDb(Object.assign({}, (this.databaseURL && { databaseURL: this.databaseURL })));
                this.attachmentId = result.attachmentId;
                this.operatingCompanies = result.operatingCompanies.map(op => ({
                    id: op.id,
                    name: op.name
                }));
                if (this.operatingCompanies.length === 1) {
                    this.operatingCompany = this.operatingCompanies[0].id.toString();
                    this.importPoleForemanForm();
                }
                else {
                    this.isSubmitButtonDisabled = true;
                }
            }
            catch (e) {
                this.handleError(i18n_1.T.FORM_IMPORT_POLEFOREMAN_ERROR_OP_CO);
            }
            finally {
                this.displayCancelButton = true;
                this.displaySubmitButton = true;
                this.loadingOperatingCompanies = false;
                this.loadedOperatingCompanies = true;
            }
        });
    }
    refreshDatabases() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                this.displayCustomButtons = true;
                this.loadingDatabases = true;
                this.isSubmitButtonDisabled = true;
                if (!((_a = services_1.Services.SSO.user) === null || _a === void 0 ? void 0 : _a.sub)) {
                    throw new Error('User not logged in');
                }
                const result = yield services_1.Services.User.rest.User.ipfDatabases({ userId: services_1.Services.SSO.user.sub });
                this.databases = result.databases;
                this.loadedDatabases = true;
                this.isSubmitButtonDisabled = true;
                if (this.databases.length === 1) {
                    this.databaseURL = this.databases[0].databaseURL;
                    this.refreshOperatingCompanies();
                }
            }
            catch (e) {
                this.handleError(i18n_1.T.FORM_IMPORT_POLEFOREMAN_ERROR_DATABASE);
            }
            finally {
                this.loadingDatabases = false;
            }
        });
    }
    handleError(msg) {
        this.setLoading(false);
        this.errorMessage = msg;
        this.displayCustomButtons = true;
    }
}
exports.FormImportPoleforemanModal = FormImportPoleforemanModal;
tslib_1.__decorate([
    mobx_1.observable
], FormImportPoleforemanModal.prototype, "loadingDatabases", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormImportPoleforemanModal.prototype, "loadedDatabases", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormImportPoleforemanModal.prototype, "loadingOperatingCompanies", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormImportPoleforemanModal.prototype, "loadedOperatingCompanies", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormImportPoleforemanModal.prototype, "attachmentId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormImportPoleforemanModal.prototype, "operatingCompany", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormImportPoleforemanModal.prototype, "databaseURL", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormImportPoleforemanModal.prototype, "databases", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormImportPoleforemanModal.prototype, "operatingCompanies", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormImportPoleforemanModal.prototype, "errorMessage", void 0);
tslib_1.__decorate([
    mobx_1.action
], FormImportPoleforemanModal.prototype, "importPoleForemanForm", null);
tslib_1.__decorate([
    mobx_1.action
], FormImportPoleforemanModal.prototype, "refreshOperatingCompanies", null);
tslib_1.__decorate([
    mobx_1.action
], FormImportPoleforemanModal.prototype, "refreshDatabases", null);
tslib_1.__decorate([
    mobx_1.action
], FormImportPoleforemanModal.prototype, "handleError", null);
//# sourceMappingURL=form.import.poleforeman.modal.js.map